import React, { Component } from "react"
import { Table, Image } from "react-bootstrap"
import dotImage from "../../assets/images/dot-img.png"
import { GovServiceDataModel } from "./OrderModels"

export interface GovOrderedServicesProps {
  service?: GovServiceDataModel,
}

export default class GovOrderedServices extends Component<GovOrderedServicesProps> {
  render() {
    const { service } = this.props
    return (
      <div>
        <Table className="table-sm dark" responsive>
          <thead>
            <tr>
              <th>SERVICE TYPE</th>
              <th></th>
              <th>ACCOUNT</th>
              <th>TEST TO BE PERFORMED</th>
            </tr>
          </thead>
          <tbody>
              <tr key={service?.id}>
                <td className="justify-content-between">
                  <span>{service?.serviceType}</span>
                </td>
                <td><Image className="ml-auto" src={dotImage} hidden={service?.isDOT !== true} /></td>
                <td>{service?.labAccount}</td>
                <td>{service?.testToPerform}</td>
              </tr>
          </tbody>
        </Table>
      </div>
    )
  }
}
